<template>
	<div class="tool-card">
		<h5>Управление слоем</h5>

		<div class="layer-controls">
			<!-- ================================= -->
			<div class="layer-control-info">Опустить / Поднять</div>
			<b-button-group class="mb-2">
				<b-button
					@click="sendBackwards"
					variant="info"
					size="sm"
					:disabled="!isSelected"
					title="Опустить"
				>
					<b-icon
						icon="chevron-double-down"
						aria-hidden="true"
					></b-icon>
					
				</b-button>
				<b-button
					@click="bringForward"
					variant="info"
					size="sm"
					:disabled="!isSelected"
					title="Поднять"
				>
					<b-icon
						icon="chevron-double-up"
						aria-hidden="true"
					></b-icon>
					
				</b-button>
			</b-button-group>
			<!-- ================================= -->
			<div class="layer-control-info">Копировать / Вставить</div>
			<b-button-group class="mb-2">
					<b-button
						@click="copyLayer"
						variant="info"
						size="sm"
						:disabled="!isSelected"
						title="Копировать"
					>
						<b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
						
					</b-button>
					<b-button @click="pasteLayer" variant="info" size="sm"
						title="Вставить"
					>
						<b-icon icon="cloud-download" aria-hidden="true"></b-icon>
						
					</b-button>
			</b-button-group>
			<!-- ================================= -->
			<div class="layer-control-info">Сгрупировать / Разгруппировать</div>
			<b-button-group class="mb-2">
				<b-button @click="group" variant="info" size="sm" title="Сгрупировать">
					<b-icon icon="columns" aria-hidden="true"></b-icon>
					</b-button
				>
				<b-button @click="ungroup" variant="info" size="sm" title="Разгруппировать">
					<b-icon icon="columns-gap" aria-hidden="true"></b-icon>
					</b-button
				>
			</b-button-group>
			<!-- ================================= -->
			<b-button-group>
				<b-button @click="selectAllLayers" variant="info" size="sm" title="Выбрать все">
					<b-icon icon="bounding-box-circles" aria-hidden="true"></b-icon>
					Выбрать все</b-button
				>
			</b-button-group>
			<!-- ================================= -->
			
		</div>

	</div>
</template>

<script>
import { fabric } from "fabric";

export default {
    props:[
        "canvas",
        "isSelected"
    ],
    methods:{
        group() {
			if (!this.canvas.getActiveObject()) {
				return;
			}
			if (this.canvas.getActiveObject().type !== "activeSelection") {
				return;
			}
			this.canvas.getActiveObject().toGroup();
			this.canvas.requestRenderAll();
		},
		ungroup() {
			if (!this.canvas.getActiveObject()) {
				return;
			}
			if (this.canvas.getActiveObject().type !== "group") {
				return;
			}
			this.canvas.getActiveObject().toActiveSelection();
			this.canvas.requestRenderAll();
		},
        selectAllLayers() {
			this.canvas.discardActiveObject();
			let sel = new fabric.ActiveSelection(this.canvas.getObjects(), {
				canvas: this.canvas,
			});
			this.canvas.setActiveObject(sel);
			this.$emit('enableEditingMode');
			this.canvas.requestRenderAll();
		},
        copyLayer() {
			this.canvas.getActiveObject().clone((cloned) => {
				this.buffer = cloned;
			});
			console.log(this.buffer);
		},
		pasteLayer() {
			this.buffer.top += 10;
			this.buffer.left += 10;
			this.canvas.add(this.buffer);
			this.canvas.setActiveObject(this.buffer);
		},
		sendBackwards() {
			let selected = this.canvas.getActiveObject();
			if (selected) {
				this.canvas.sendBackwards(selected);
			}
		},
		bringForward() {
			let selected = this.canvas.getActiveObject();
			if (selected) {
				this.canvas.bringForward(selected);
			}
		},
        // removeLayer() {
		// 	let target = this.canvas.getActiveObject();
		// 	this.group()
		// 	if (target) {
		// 		this.canvas.remove(target);
		// 		this.canvas.requestRenderAll();
		// 	}
		// },
    }
};
</script>

<style></style>
